import { DeleteApi, GetApi } from "../../services/ApiService";

// get inspection details by location and employee
export const getInspectionDetails = async (setloading, poolId, userId) => {
  try {
    setloading(true);
    let response = [];
    if (poolId?.value !== -1) {
      response = await GetApi(
        `/pools/inspectiondetails_with_paging/${poolId?.value}/user/${userId?.value}`
      );
    }
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

// get inspection details by Date
export const getInspectionDetailsByDate = async (setloading, visitDate) => {
  try {
    setloading(true);
    let response = [];
    response = await GetApi(
      `/pools/inspectiondetails_with_visitedDate/${visitDate}`
    );
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

export const getLocations = async (setloading) => {
  try {
    setloading(true);
    let response = await GetApi(`/pools`);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

export const getVisitBy = async (setloading) => {
  try {
    setloading(true);
    let response = await GetApi(`/pools/visitedby/-1`);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};

// deleet inspection by visit Id
export const deleteInspection = async (setloading, visitId) => {
  try {
    setloading(true);
    let response = [];
    response = await DeleteApi(`/pools/visit/${visitId}`);
    setloading(false);
    return response;
  } catch (error) {
    setloading(false);
    console.log(error);
    return [];
  }
};
